module.exports = __webpack_public_path__ + "dz.svg?28f89f681c28ebecc18251e4674009e6";